import React from "react"
import "./index.scss"

export default function InnerPostSignupForm({ component }) {
  const { everyActionFormLink } = component
  return (
    <div data-datocms-noindex className="formWrapper bannerForm">
      <link
        rel="preload"
        href="https://d3rse9xjbp8270.cloudfront.net/at.js"
        as="script"
        crossorigin="anonymous"
      />
      <link
        rel="preload"
        href="https://d3rse9xjbp8270.cloudfront.net/at.min.css"
        as="style"
      />
      <script
        type="text/javascript"
        src="https://d3rse9xjbp8270.cloudfront.net/at.js"
        crossorigin="anonymous"
      ></script>
      <iframe
        src={`https://secure.everyaction.com/${everyActionFormLink}`}
      ></iframe>
    </div>
  )
}
